import axios from "axios";
import Agent from "agentkeepalive";
import api from "../components/axiosInstance";
import { getActiveServer } from "../components/serverManager";
//import https from "https"
//console.log()
//const url=""
// const sname=window.localStorage.getItem("server_name")
// if(sname=="AWS"){
//     url="https://jetovacations.in"
// }else if(sname=="Azure"){
//     url="https://jetocrm-server.azurewebsites.net"
// }else if(sname=="Heroku"){
//     url="https://jetocrm-project.herokuapp.com"
// }else {
//     console.log("Unknown Server")
// }
//export const url="http://jetocrmserverv2-env.eba-2w3gt64u.ap-south-1.elasticbeanstalk.com/"
//const url="www.jetovacations.in"
export const url = getActiveServer();
//do not use-- const url="http://jetovacations.in"
//export const url="https://jetovacations.in"
//export const url="https://jetovacation.com"
//export const url="https://web-production-6467.up.railway.app"
//export const url="https://3.108.245.168:5000"
//export const url="https://jetocrm-server.azurewebsites.net"
//export const url="https://jeto-crm-server.onrender.com"
//const url="https://jetocrm-project.herokuapp.com"
//export const url="http://jeto-crm-server2025-env.eba-y4bdyuat.ap-south-1.elasticbeanstalk.com/"
//export const url="http://localhost:5000"
//web-production-5e65.up.railway.app
//const url="https://3825-2405-201-9007-6ac2-6927-8dc7-ce39-b410.in.ngrok.io"
export const railwayurl = "https://web-production-6467.up.railway.app";
const erurl =
  "https://v6.exchangerate-api.com/v6/ee177ef4fabd0364d88dfb3e/latest/";
const getgabsurl =
  "https://app.getgabs.com/whatsappbusiness/send-templated-message";

const keepAliveAgent = new Agent({
  maxSockets: 128, // or 128 / os.cpus().length if running node across multiple CPUs
  maxFreeSockets: 128, // or 128 / os.cpus().length if running node across multiple CPUs
  timeout: 600000, // active socket keepalive for 60 seconds
  freeSocketTimeout: 600000, // free socket keepalive for 30 seconds
});

//const httpsAgent =  new https.Agent({ keepAlive: true })

const axiosInstance = axios.create({
  // Create an agent for both HTTP and HTTPS
  httpAgent: keepAliveAgent,
  //httpsAgent: httpsAgent,
  timeout: 600000,
  //httpsAgent: httpsKeepAliveAgent,
});

// export const svtoken="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjEyMjc4MCwiaXNzIjoiaHR0cHM6XC9cL2N1c3RvbWVyLnNlcnZldGVsLmluXC90b2tlblwvZ2VuZXJhdGUiLCJpYXQiOjE2OTA0Mzk2NjAsImV4cCI6MTk5MDQzOTY2MCwibmJmIjoxNjkwNDM5NjYwLCJqdGkiOiJjNkZBU3BVMjJ2YjlFb09GIn0.35Lh97xf0Bk1A4Wuv_FSoRgR8sBS6ilOCRsXHXUbOZg"

export const svtoken =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxOTEyMzIiLCJpc3MiOiJodHRwczovL2NvbnNvbGUuYWNlZm9uZS5pbi90b2tlbi9nZW5lcmF0ZSIsImlhdCI6MTcyNzA5MzEzNCwiZXhwIjoyMDI3MDkzMTM0LCJuYmYiOjE3MjcwOTMxMzQsImp0aSI6IlRLVTRuSk1DZHNOU2UwV3oifQ.sU7LW9EQSFkYUaZSBuu4Hq1MHFRLVcrbDqC4f0uzIIQ";

export const fetchInfo = () => api.get("/listinfodata");
export const updateInfoData = (id, newinfoData) =>
  api.patch(url + "/updateinfo", { params: { id, newinfoData } });
export const fetchCustomers = () => api.get("/listcustdata/all");
export const fetchOpenCustomers = () => api.get("/listcustdata/open");
export const fetchmarketingcustlist = (startdate, enddate) =>
  api.get("/listmktngcustdata", { params: { startdate, enddate } });
export const fetchmarketingcustlist2 = (startdate, enddate) =>
  api.get("/listmktngcustdata2", { params: { startdate, enddate } });
export const fetchmarketingcustlist3 = (startdate, enddate) =>
  api.get("/listmktngcustdata3", { params: { startdate, enddate } });
export const fetchmarketingcustlist4 = (startdate, enddate) =>
  api.get("/remarketing", { params: { startdate, enddate } });
export const fetchActiveCustomers = () => api.get("/listcustdata");
export const fetchCustomerbyId = (id) => api.get("/custdataentry/" + id);
export const fetchCustomerbyNumber = (number) =>
  api.get("/listcustdata/mobilenumber", { params: { number } });
export const fetchCustomerbyDate = (startdate, enddate) =>
  api.get("/listcustdata/custbydate", { params: { startdate, enddate } });
export const fetchCustomerbyDate2 = (startdate, enddate) =>
  api.get("/listcustdata/custbydate2", { params: { startdate, enddate } });
export const addCustomer = (newCust) => api.post("/custdataentry", newCust);
export const searchCustomersbyNumber = (number) =>
  api.get("/searchcustbynumber", { params: { number } });
export const openfupcountbysp = (owner) =>
  api.get("/listCustOpenbySP", { params: { owner } });
export const getloyalty = (custid) =>
  api.get("/listcustdata/loyalty", { params: { custid } });
export const searchCustomersbymail = (email) =>
  api.get("/searchcustbyemail", { params: { email } });
export const fetchCustomersbyOwner = (owner) =>
  api.get("/listcustdata/owner", { params: { owner } });
export const fetchtodaycust = () => api.get("/listcustdata/today");
export const fetchcustbydob = (month) =>
  api.get("/listcustdatabydob", { params: { month } });
export const updateCustdata = (id, newcustData) =>
  api.patch("/custdataentry/" + id, newcustData);
export const fetchfutureconvTrips = () => api.get("/listtripsdata/futureconv");
export const fetchTrips = () => api.get("/listtripsdata/all");
export const fetchActiveTrips = () => api.get("/listtripsdata");
export const fetchQMTrips = () => api.get("/listqmtripsdata");
export const fetchconvcustdata = (startdate, enddate) =>
  api.get("/listconvcustdata", { params: { startdate, enddate } });
export const searchupdatedTripsbyDate = (startdate, enddate) =>
  api.get("/listtripsdata/updatedbydate", { params: { startdate, enddate } });
export const overrideTripsbyDate = (startdate, enddate) =>
  api.get("/listtripsdata/overridetrips", { params: { startdate, enddate } });
export const fetchTripsbyStatus = (status) =>
  api.get("/listtripsdata/status", { params: { status } });
export const fetchTripsbyDest = (dest) =>
  api.get("/listtripsdata/dest", { params: { dest } });
export const fetchTripsbyStatusandOwner = (status, owner) =>
  api.get("/listtripsdata/statusowner", { params: { status, owner } });
export const fetchActiveFupTrips = () => api.get("/listtripsfupdata");
export const addTrip = (newTrip) => api.post("/tripdataentry", newTrip);
export const addleadTrip = (newTrip) => api.post("/leadtripdataentry", newTrip);
export const deleteTripbyId = (tripid) =>
  api.post("/tripdatadelete", { params: { tripid } });
export const adddupTrip = (newTrip) => api.post("/duptripentry", newTrip);
export const TestTC = (newTrip) => api.post("/tclead", newTrip);
export const fetchTripbyId = (id) => api.get("/tripdataentry/" + id);
export const fetchTripbyId2 = (id) => api.get("/tripdataentry2/" + id);
export const fetchActiveTripsbyTripOwner = (owner) =>
  api.get("/listtripsdata/tripowner", { params: { owner } });
export const getPostponedtrips = () => api.get("/listtripsdata/postponedfup");
export const getallPostponedtrips = () =>
  api.get("/listtripsdata/getpostponed");
export const gmailSend = (from, to, subject, body, cc, formData, formData2) =>
  api.post("/gmailSend", {
    params: { from, to, subject, body, cc, formData, formData2 },
  });
export const fetchActiveFupTripsbyTripOwner = (owner) =>
  api.get("/listtripsdata/tripfupowner", { params: { owner } });
export const fetchfunnellength = (owner) =>
  api.get("/listtripsdata/funnellength", { params: { owner } });
export const fetchpostponedlength = (owner) =>
  api.get("/listtripsdata/postponedlength", { params: { owner } });
export const fetchpintrip = (owner) =>
  api.get("/listtripsdata/pintrip", { params: { owner } });
export const getactivefunnellength = (owner) =>
  api.get("/activefunnellength", { params: { owner } });
export const fetchtripsbyairport = (airport) =>
  api.get("/listtripsdata/getbyairport", { params: { airport } });
export const updateTripdata = (id, newtripData) =>
  api.patch("/tripdataentry/" + id, newtripData);
export const updateTripflightdata = (usertripdata) =>
  api.post("/updateflightstatus", usertripdata);
export const searchTrips = (owner, startdate, enddate) =>
  api.get("/searchtrip", { params: { owner, startdate, enddate } });
export const searchpassiveTrips = (status, owner, startdate, enddate) =>
  api.get("/searchpassivetrip", {
    params: { status, owner, startdate, enddate },
  });
export const searchTripsbyDate = (startdate, enddate) =>
  api.get("/analyticsdata", { params: { startdate, enddate } });
export const fetchacceptedtripsbydate = (startdate, enddate) =>
  api.get("/listtripsdata/acceptedtrips", { params: { startdate, enddate } });
export const searchTripsbycreateddateandOwner = (owner, startdate, enddate) =>
  api.get("/searchcreatedbydateowner", {
    params: { owner, startdate, enddate },
  });
export const searchpotentialhot = (owner, startdate, enddate) =>
  api.get("/searchpotentialhot", { params: { owner, startdate, enddate } });
export const searchTripsbyDate2 = (startdate, enddate) =>
  api.get("/analyticstripsdata", { params: { startdate, enddate } });
export const searchcreatedTripsbyDate = (startdate, enddate) =>
  api.get("/createdtripsbydate", { params: { startdate, enddate } });
export const searchActiveTripsbyDate = (startdate, enddate) =>
  api.get("/listactivebydate", { params: { startdate, enddate } });
export const searchQCbyDate = (startdate, enddate) =>
  api.get("/analyticsqcdata", { params: { startdate, enddate } });
export const searchQCbyDateandOwner = (startdate, enddate, owner) =>
  api.get("/analyticsqcdataowner", { params: { startdate, enddate, owner } });
export const searchQEbyDate = (startdate, enddate) =>
  api.get("/analyticsqedata", { params: { startdate, enddate } });
export const newsearchQEbyDate = (startdate, enddate) =>
  api.get("/analyticsnewqedata", { params: { startdate, enddate } });
export const newsearchQEbyDate2 = (startdate, enddate) =>
  api.get("/analyticsnewqedata2", { params: { startdate, enddate } });
export const searchQEbyDateandOwner = (startdate, enddate, owner) =>
  api.get("/analyticsqedataowner", { params: { startdate, enddate, owner } });
export const newsearchQEbyDateandOwner = (startdate, enddate, owner) =>
  api.get("/analyticsnewqedataowner", {
    params: { startdate, enddate, owner },
  });
export const searchconvTripsbyDate = (startdate, enddate) =>
  api.get("/analyticsconvdata", { params: { startdate, enddate } });
export const searchconvTripsbyDate2 = (startdate, enddate) =>
  api.get("/analyticsconvdata2", { params: { startdate, enddate } });
export const searchboTripsbyDate = (startdate, enddate) =>
  api.get("/analyticsbodata", { params: { startdate, enddate } });
export const searchboTripsbyDate2 = (startdate, enddate) =>
  api.get("/analyticsbodata2", { params: { startdate, enddate } });
export const searchboTripsbyDate3 = (startdate, enddate, user) =>
  api.get("/analyticsbodata3", { params: { startdate, enddate, user } });
export const searchTripsbyStartDate = (startdate, enddate) =>
  api.get("/searchtripbystartdate", { params: { startdate, enddate } });
export const searchTripsbyStartDate3 = (startdate, enddate) =>
  api.get("/searchtripbystartdate3", { params: { startdate, enddate } });
export const searchConvTripsbyStartDate = (startdate, enddate) =>
  api.get("/searchconvtripbystartdate", { params: { startdate, enddate } });
export const searchpersonalConvTripsbyStartDate = (startdate, enddate) =>
  api.get("/listtripsdata/personalconv", { params: { startdate, enddate } });
export const searchconvTripsbyDatenOwner = (startdate, enddate, owner) =>
  api.get("/convdateowner", { params: { startdate, enddate, owner } });
export const searchTripsbyStartDateandowner = (startdate, enddate, cuser) =>
  api.get("/searchtripbystartdateowner", {
    params: { startdate, enddate, cuser },
  });
export const searchcancTripsbyDate = (startdate, enddate) =>
  api.get("/analyticscancdata", { params: { startdate, enddate } });
export const searchallTripsbyDate = (startdate, enddate) =>
  api.get("/analyticsalldata", { params: { startdate, enddate } });
export const searchclosedTripsbyDate = (startdate, enddate) =>
  api.get("/analyticscloseddata", { params: { startdate, enddate } });
export const searchclosedDABTripsbyDate = (startdate, enddate) =>
  api.get("/analyticscloseddabdata", { params: { startdate, enddate } });
export const searchDABTripsbyDate = (startdate, enddate) =>
  api.get("/analyticsdabdata", { params: { startdate, enddate } });
export const fetchstatushistory = (tripid) =>
  api.get("/fetchstatushistory", { params: { tripid } });
export const searchhotTripsbyDate = (startdate, enddate) =>
  api.get("/analyticshotdata", { params: { startdate, enddate } });
export const searchcancelledTripsbyDate = (startdate, enddate) =>
  api.get("/listtripsdata/cancelledbyDate", { params: { startdate, enddate } });
export const searchsuperhotTripsbyDate = (startdate, enddate) =>
  api.get("/analyticssuperhotdata", { params: { startdate, enddate } });
export const searchhotTripsbyDate2 = (startdate, enddate) =>
  api.get("/analyticshotdata2", { params: { startdate, enddate } });
export const searchpotentialTripsbyDate = (startdate, enddate) =>
  api.get("/analyticspotdata", { params: { startdate, enddate } });
export const searchQuotesbyDate = (startdate, enddate, dest) =>
  api.get("/analyticsquotedata", { params: { startdate, enddate, dest } });
export const searchLeadsbyDate = (startdate, enddate) =>
  api.get("/analyticsleadsdata", { params: { startdate, enddate } });
export const searchLeadsbyDate3 = (startdate, enddate) =>
  api.get("/analyticsleadsdata3", { params: { startdate, enddate } });
export const searchupdatedLeadsbyDate = (startdate, enddate) =>
  api.get("/listupdatedleadsdata", { params: { startdate, enddate } });
export const searchconvTripsbyStartDate = (startdate, enddate) =>
  api.get("/analyticsstartdata", { params: { startdate, enddate } });
export const fetchupdatedtripsbyDate = (startdate, enddate) =>
  api.get("/analyticscalldata", { params: { startdate, enddate } });
export const getupsellprofit = (startdate, enddate) =>
  api.get("/listtripsdata/upsell", { params: { startdate, enddate } });
export const getlpdata = (startdate, enddate) =>
  api.get("/getlpdata", { params: { startdate, enddate } });
export const getactiveluxury = () => api.get("/listactiveluxury");
export const getluxury = () => api.get("/listtripsdata/getluxury");
export const getluxuryquotes = () => api.get("/listluxuryquotedata");
export const gettripfromleadidlist = (arr) =>
  api.post("/gettripfromleadidlist", arr);
export const getmanualfr = () => api.get("/getmanualfr");
export const getmanualfrbydate = (startdate, enddate) =>
  api.get("/getmanualfrbydate", { params: { startdate, enddate } });
export const getmanualfrbydate2 = (startdate, enddate) =>
  api.get("/getmanualfrbydate2", { params: { startdate, enddate } });
export const freezeprofit = (arr) => api.post("/freezeprofit", arr);
export const autob2s = (tripid) => api.post("/autob2s", tripid);
export const fetchReftrips = (startdate, enddate) =>
  api.get("/listtripsdata/reftrips", { params: { startdate, enddate } });
export const fetchconvdate = (tripid) =>
  api.get("/listtripsdata/getconvdate", { params: { tripid } });
export const gethighprofitsearch = () => api.get("/listtripsdata/profittrips");
export const fetchTripsbyCompetitionDate = (startdate, enddate) =>
  api.get("/listtripsdata/competitiondate", { params: { startdate, enddate } });
export const fetchFollowups = () => api.get("/fup");
export const analyzeDocumentviaAI = (link) =>
  api.post("/aidocumentextract", link);
export const analyzeDocumentsviaAI = (linkarr) =>
  api.post("/aimultidocumentextract", linkarr);
//export const fetchtestfunction = () => api.get("/testfunction",{responseType:"blob"});
export const fixdupcust = () => api.patch("/fixdupcustcheck");
export const fetchtestfunction = () => api.get("/testfunction");
export const fetchtodaytrips = () => api.get("/listtripsdata/today");
export const fetchtodaycanctrips = () => api.get("/listtripsdata/canctoday");
export const fetchtodayhottrips = () => api.get("/listtripsdata/hottoday");
export const fetchtodayconvtrips = () => api.get("/listtripsdata/convtoday");
export const fetchbyholdops = () => api.get("/listtripsdata/searchbyholdops");
export const fetchtcsquery = (startdate, enddate) => api.get("/listtripsdata/tcsquery", { params: { startdate, enddate } });
export const fetchtripsbybookingdate = (startdate, enddate) => api.get("/listtripsdata/searchtripsbybookingdate", { params: { startdate, enddate } });
export const fetchtodaypostponedtrips = () =>
  api.get("/listtripsdata/postponedtoday");
export const fetchtodayfup = () => api.get("/listtripsdata/fuptoday");
export const fetchupdatedtodaytrips = () =>
  api.get("/listupdatedtripsdata/today");
export const checkfastreach = (leadid) =>
  api.get("/checkfastreach", { params: { leadid } });
export const fetchfupbydate = (startdate, enddate) =>
  api.get("/listtripsdata/fupbydate", { params: { startdate, enddate } });
export const fetchnrfupbydate = (startdate, enddate) =>
  api.get("/listtripsdata/nrfupbydate", { params: { startdate, enddate } });
export const fetchcancflagbydate = (startdate, enddate) =>
  api.get("/listtripsdata/cancflagbyDate", { params: { startdate, enddate } });
export const getprojectionfromserver = (startdate, enddate) =>
  api.get("/getprojection", { params: { startdate, enddate } });
export const fetchcancflagbydateandowner = (startdate, enddate, owner) =>
  api.get("/listtripsdata/cancflagbyDateandowner", {
    params: { startdate, enddate, owner },
  });
export const fetchactivetripscount = (startdate) =>
  api.get("/activetripcount", { params: { startdate } });
export const fetchtriphistory = (number) =>
  api.get("/listtripsdata/fetchtriphistory", { params: { number } });
export const fetchquotedatesonly = (id) =>
  api.get("/listquotesdata/getquotedatesonly", { params: { id } });
export const canceltripbytripid = (id) =>
  api.get("/canctripbytripid", { params: { id } });
export const fetchtripstatusoftripids = (arr) =>
  api.post("/fetchstatusbyids", arr);
export const viewprojection = (startdate, enddate) =>
  api.get("/listtripsdata/viewprojection", { params: { startdate, enddate } });
export const reactivatebydate = (startdate, enddate) =>
  api.get("/reactivatebydate", { params: { startdate, enddate } });

export const addHotel = (newHotel) => api.post("/hoteldataentry", newHotel);
export const sendpurchasetoMeta = (trip) =>
  api.post("/sendPurchaseToMeta", trip);
export const fetchHotels = () => api.get("/listhoteldata");
export const fetchHotelsname = () => api.get("/listhoteldata/name");
export const fetchHotelbyId = (id) => api.get("/hoteldataentry/" + id);
export const fetchdestHotels = (tripid) =>
  api.get("/listhoteldata/tripid", { params: { tripid } });
export const fetchdestHotelsbyDest = (dest) =>
  api.get("/listhoteldata/dest", { params: { dest } });
export const fetchdestHotelsbyDestandCity = (dest, city) =>
  api.get("/listhoteldata/destandcity", { params: { dest, city } });
export const fetchdestHotelsbyQuoteid = (quoteid) =>
  api.get("/listhoteldata/quoteid", { params: { quoteid } });
export const fetchHotelsbyUSP = (data, dest) =>
  api.get("/searchhotelbyusp", { params: { data, dest } });
export const fetchHotelsbyTagsOr = (
  tag1,
  tag2,
  tag3,
  tag4,
  tag5,
  tag6,
  tag7,
  tag8,
  data,
) =>
  api.get("/searchhotelbytagsor", {
    params: { tag1, tag2, tag3, tag4, tag5, tag6, tag7, tag8, data },
  });
export const fetchHotelsbyTagsAnd = (
  tag1,
  tag2,
  tag3,
  tag4,
  tag5,
  tag6,
  tag7,
  tag8,
  data,
) =>
  api.get("/searchhotelbytagsand", {
    params: { tag1, tag2, tag3, tag4, tag5, tag6, tag7, tag8, data },
  });
export const fetchcommentedbydate = (startdate, enddate) =>
  api.get("/commentedbydate", { params: { startdate, enddate } });
export const runcancflagcheck = (tripid) =>
  api.get("/cancflagcheck", { params: { tripid } });
export const updateHoteldata = (id, newhotelData) =>
  api.patch("/hoteldataentry/" + id, newhotelData);
export const addTour = (newTour) => api.post("/tourdataentry", newTour);
export const fetchTours = () => api.get("/listtourdata");
export const fetchdestTours = (tripid) =>
  api.get("/listtourdata/tripid", { params: { tripid } });
export const fetchdestToursbyQuoteid = (quoteid) =>
  api.get("/listtourdata/quoteid", { params: { quoteid } });
export const fetchdestToursbyDest = (dest) =>
  api.get("/listtourdata/dest", { params: { dest } });
export const fetchTourbyId = (id) => api.get("/tourdataentry/" + id);
export const updatetourrates = (id) => api.get("/updatetourrates/");
export const gettoursbydesc = (phrase) => api.post("/getourbydesc", phrase);
export const gettouritinerary = (arr) => api.post("/gettouritinerary", arr);
//export const updateTourdata = (id, newtourData) => api.patch("/tourdataentry/"+newtourData.tour_id, newtourData);
export const updateTourdata = (id, newtourData) =>
  api.patch("/tourdataentry/" + id, newtourData);
export const fetchSuppliers = () => api.get("/listsupplierdata");
export const fetchSuppliersbyDest2 = (dest) =>
  api.get("/listsupplierdata/dest2", { params: { dest } });
export const addSupplier = (newSupplier) =>
  api.post("/supplierdataentry", newSupplier);
export const fetchSupplierbyId = (id) => api.get("/supplierdataentry/" + id);
export const updateSupplierdata = (id, newsupplierData) =>
  api.patch("/supplierdataentry/" + id, newsupplierData);
export const fetchDest = () => api.get("/listdest");

export const fetchConvertedTrips = () => api.get("/home/owner");
export const fetchConvertedTripsOnly = () => api.get("/listtripsdata/convonly");
export const fetchConvertedTripsbyTourid = (tourid) =>
  api.get("/listtripsdata/fetchtripbytourid", { params: { tourid } });
export const fetchConvertedTripsbyHotelid = (hotelid) =>
  api.get("/listtripsdata/fetchtripbyhotelid", { params: { hotelid } });
export const fetchConvertedTripsbyHotelid2 = (hotelid) =>
  api.get("/listtripsdata/fetchtripbyhotelid2", { params: { hotelid } });
export const fetchtripbycreateddate = (startdate, enddate) =>
  api.get("/listtripsdata/fetchtitaniumtrips", {
    params: { startdate, enddate },
  });
export const fetchConvertedTripsbyTripOwner = (owner) =>
  api.get("/listtripsdata/convowner", { params: { owner } });
export const fetchConvertedTripsbyTripOwnerOnly = (owner) =>
  api.get("/home/all", { params: { owner } });
export const fetchCanc = (cancdate) =>
  api.get("/home/canc", { params: { cancdate } });
export const fetchCancbyOwner = (owner, cancdate) =>
  api.get("/home/cancowner", { params: { owner, cancdate } });
export const fetchSuppliersbyDest = (dest) =>
  api.get("/listsupplierdata/dest", { params: { dest } });
export const fetchreviewhotel = (startdate, enddate) =>
  api.get("/reviewhotel", { params: { startdate, enddate } });

export const fetchEmployees = () => api.get("/listemployeedata");
export const fetchEmployeebyId = (id) => api.get("/employeedataentry/" + id);
export const addEmployee = (newEmployee) =>
  api.post("/employeedataentry", newEmployee);
export const updateEmployeedata = (id, newemployeeData) =>
  api.patch("/employeedataentry/" + id, newemployeeData);

export const fetchProjects = () => api.get("/listprojectdata");
export const fetchProjectbyId = (id) => api.get("/projectdataentry/" + id);
export const addProject = (newProject) =>
  api.post("/projectdataentry", newProject);
export const updateProjectdata = (id, newProjectData) =>
  api.patch("/projectdataentry/" + id, newProjectData);
export const fetchProjectbyDept = (dept) =>
  api.get("/projectdatasearchbydept/" + dept);

export const addWAreport = (waData) => api.post("/wareportentry", waData);
export const getWAdata = () => api.get("/listwareportdata");

export const fetchallFd = () => api.get("/listfd");
export const fetchactiveFd = () => api.get("/listactivefd");
export const addFd = (newFd) => api.post("/createfd", newFd);
export const fetchFdbyId = (id) => api.get("/getfdbyid/" + id);
export const fetchFdbyDest = (dest) => api.get("/getfdbydest/" + dest);
export const updateFd = (id, newFd) => api.patch("/updatefd/" + id, newFd);

export const addquoteData = (newQuote) => api.post("/quotedataentry", newQuote);
export const fetchfavQuotes = () => api.get("/listquotedata");
export const fetchfavQuotesbyDest = (dest) =>
  api.get("/listquotesdata/dest", { params: { dest } });
export const fetchQuotebyId = (id) => api.get("/quotedataentry/" + id);
export const fetchQuotebyIdGroup = (number) =>
  api.get("/listquotedatabyidgroup", { params: { number } });
export const updatequoteData = (id, newquoteData) =>
  api.patch("/quotedataentry/" + id, newquoteData);
export const fetchEmployeebyName = (name) =>
  api.get("/employeedatasearch/" + name);
export const fetchTeambyName = (name) => api.get("/teamdatasearch/" + name);
export const fetchEmployeebyEmail = (email) =>
  api.get("/employeedatasearchbymail/" + email);
export const fetchtodayquotes = () => api.get("/listquotesdata/today");
export const fetchtodayeditquotes = () => api.get("/listquotesdata/edittoday");
export const fetchpotentialhot = () => api.get("/potentialhot");
export const fetchquotetoday = () => api.get("/quotetoday");
export const fetchquotefromlist = (quotelist) =>
  api.get("/getquotefromlist", { params: { quotelist } });
export const fetchquotefromlist2 = (quotelist) =>
  api.get("/getquotefromlist2", { params: { quotelist } });
export const fetchquotefromtrip = (quotelist) =>
  api.get("/listquotesdata/getquotefromtrip", { params: { quotelist } });

export const addLead = (newLead) => api.post("/lead", newLead);
export const addInternalLead = (newLead) => api.post("/weblead", newLead);
export const addTCLeads = (hh, mm) =>
  api.post("/tclead", { params: { hh, mm } });
export const fetchLeads = () => api.get("/listleadsdata/all");
export const fetchLeads15 = () => api.get("/listleadsdata/last15days");
export const fetchLeads7to90 = () => api.get("/listleadsdata/listLeads7to90");
export const fetchLeads10mins = () => api.get("/listleadsdata/last10mins");
export const fetchLeadsbyNumber = (number) =>
  api.get("/listleadsdata/leadnumber", { params: { number } });
export const fetchLeadsbyName = (name) =>
  api.get("/listleadsdata/name", { params: { name } });
export const fetchTripsbyNumber = (number) =>
  api.get("/listtripsdata/mobilenumber", { params: { number } });
export const fetchTripsbyNumber2 = (number) =>
  api.post("/listtripsdata/searchtripsbynumber", number);
export const fetchdupTripsbyNumber = (number) =>
  api.post("/listtripsdata/duptripsbynumber", number);
export const fetchfunnelsize = () => api.get("/listtripsdata/funnelsize");
export const fetchTripsbyName = (name) =>
  api.get("/listtripsdata/name", { params: { name } });
export const fetchLeadsbyEmail = (email) =>
  api.get("/listleadsdata/leademail", { params: { email } });
export const fetchLeadsbyTripOwner = (owner) =>
  api.get("/listleadsdata/leadowner", { params: { owner } });
export const fetchLeadsTodaybyTripOwner = (owner) =>
  api.get("/listleadsdata/todayowner", { params: { owner } });
export const fetchLeadsbydateandproj = (startdate, enddate, fields) =>
  api.post("/listleadsdata/proj", { params: { startdate, enddate, fields } });
export const fetchLeadbyId = (id) => api.get("/lead/" + id);
export const updateLeaddata = (id, newleadData) =>
  api.patch("/lead/" + id, newleadData);
export const newupdateLeaddata = (leadid, name, cuser) =>
  api.patch("/updatelead/", { params: { leadid, name, cuser } });
export const newupdateLeaddata3 = (leadid, name, cuser) =>
  api.patch("/updatelead3/", { params: { leadid, name, cuser } });
export const newupdateCustdata = (custid, name, cuser) =>
  api.patch("/updatecustowner/", { params: { custid, name, cuser } });
export const fetchquotelist = (dest) =>
  api.get("/quotelist", { params: { dest } });
export const fetchtodayleads = () => api.get("/listleadsdata/today");
export const fetchworkfalseleads = () =>
  api.get("/listleadsdata/workfalseleads");
export const fetchtodayassignedleads = () =>
  api.get("/listleadsdata/assignedtoday");
export const fetchtodayupdatedleads = () =>
  api.get("/listupdatedleadsdata/today");
export const fetchtodayupdatedleadsTL = () =>
  api.get("/listupdatedleadsdata/tl");
export const fetchworkdoneleads = () => api.get("/listleadsdata/workdonetoday");
export const fetchworkdonefastreach = (startdate, enddate) =>
  api.get("/listleadsdata/getfastreach", { params: { startdate, enddate } });
export const fetchworkdoneleadsbydate = (startdate, enddate) =>
  api.get("/listleadsdata/workdonebydate", { params: { startdate, enddate } });
export const fetchleadsbydate2 = (startdate, enddate) =>
  api.get("/listleadsdata/leadbydate2", { params: { startdate, enddate } });
export const getsupplierrecord = (startdate, enddate, id) =>
  api.get("/listtripsdata/supplierpaymentrecord", {
    params: { startdate, enddate, id },
  });
export const getsupplierbookingrecord = (startdate, enddate, id) =>
  api.get("/listtripsdata/supplierbookingrecord", {
    params: { startdate, enddate, id },
  });
export const fetchleadsbyid2 = (id) =>
  api.get("/listleadsdata/leadbyid2/" + id);
export const fetchleadsbynumber2 = (number) =>
  api.post("/listleadsdata/leadbynumber2", number);
export const reactivatebyNumber = (number) =>
  api.get("/reactivatetrip/" + number);
export const fetchleadbasedcustdata = (startdate, enddate) =>
  api.get("/leadbasedcustdata", { params: { startdate, enddate } });

export const dupcustCheck = () => api.get("/dupcustcheck");
export const duptripCheck = () => api.get("/duptripcheck");
export const duptripnumberCheck = () => api.get("/duptripnumberCheck");
export const dupquoteCheck = () => api.get("/dupquotecheck");
export const duphotelCheck = () => api.get("/duphotelcheck");
export const dupleadCheck = () => api.get("/dupleadcheck");
export const duptourCheck = () => api.get("/duptourcheck");
export const dupcustnumberCheck = () => api.get("/dupcustnumbercheck");
export const notrecohotel = () => api.get("/notrecohotels");
export const duplicatetrips = () => api.get("/duplicatetrips");

export const fetchwadata = () => api.get("/listwadata/all");
export const addMsg = (newMsg) => api.post("/wamsg", newMsg);
export const fetchcurrency = (currencyname) => api.get(erurl + currencyname);
export const fetchCurrencyData = () => api.get("/listcurrency");
export const updateCurrencyData = (id, newcurrencyData) =>
  api.patch("/updatecurrency", { params: { id, newcurrencyData } });
export const fetchVisaData = () => api.get("/listvisa");

export const gettlreport = (date) =>
  api.get("/gettreport", { params: { date } });
export const addtlreport = (newMsg) => api.post("/submitreport", newMsg);
export const updatetlreport = (newMsg) => api.post("/updatereport", newMsg);
export const gethottrips = () => api.get("/gethottrips");

export const fetchTokenData = () => api.get("/listtoken");
export const fetchToken = (body) => api.post("/fetchtoken", body);
export const refreshTCToken = (body) => api.post("/refreshtctoken", body);
export const searchTCflight = (body) => api.post("/searchtravclanflight", body);
export const updateTokenData = (id, newtokenData) =>
  api.patch("/updatetoken", { params: { id, newtokenData } });

export const fetchflights = (body) => api.post("/searchflights", body);
export const fetchfarerule = (body) => api.post("/farerule", body);
export const fetchfarequote = (body) => api.post("/farequote", body);
export const fetchssr = (body) => api.post("/ssr", body);
export const fetchbook = (body) => api.post("/bookflight", body);
export const fetchticket = (body) => api.post("/ticket", body);
export const fetchdetails = (body) => api.post("/getdetails", body);
export const releasepnr = (body) => api.post("/releasepnr", body);
export const cancelflight = (body) => api.post("/cancelflight", body);
export const requeststatus = (body) => api.post("/requeststatus", body);
export const getcpafterflightbooking = (body) => api.post("/getflightcp", body);

export const addflightData = (newTBO) => api.post("/loadflightbooikng", newTBO);
export const fetchflightconfbooking = () =>
  api.get("/fetchflightconfirmBooking");
export const fetchflightallbooking = () => api.get("/fetchallflightbooking");
export const updateflightdata = (newTBOData) =>
  api.patch("/updateflightconfbooking", newTBOData);

export const puppeteertest = (msg) => api.post("/puppeteer", msg);
export const bulkmsg = (list, msg) =>
  api.post("/bulkmsg1", { params: { list, msg } });
export const leadassignment = () => api.get("/leadassignment");
export const newleadassignment = () => api.get("/newleadassignment");

export const imgupload = (data) => api.post("/imgupload", data);
export const imgdelete = (data) =>
  api.delete("/imgdelete", { params: { data } });
export const downloadfile = (data) =>
  api.get(
    "/downloadfile",
    { params: { data } },
    { responseType: "arraybuffer" },
  );

export const startcron = () => api.get("/startcron");
export const stopcron = () => api.get("/stopcron");
export const cancflag = () => api.get("/runcancflag");

export const fetchActiveTripsbyTL = (owner) =>
  api.get("/listtripsdata/tl", { params: { owner } });
export const fetchConvertedTripsbyTL = (owner) =>
  api.get("/listtripsdata/convtl", { params: { owner } });
export const fetchConvertedTripsbyTLnDate = (owner, startdate, enddate) =>
  api.get("/listtripsdata/convtlndate", {
    params: { owner, startdate, enddate },
  });
export const fetchCancbyTL = (owner, cancdate) =>
  api.get("/home/canctl", { params: { owner, cancdate } });
export const fetchLeadsbyTL = (owner) =>
  api.get("/listleadsdata/leadtl", { params: { owner } });
export const fetchCustomersbyTL = (owner) =>
  api.get("/listcustdata/tl", { params: { owner } });
export const fetchTripsbyStatusTL = (status, owner) =>
  api.get("/listtripsdata/statustl", { params: { status, owner } });
export const fetchActiveTripsTL = (owner) =>
  api.get("/listtripsdatatl", { params: { owner } });
export const fetchtodayassignedleadsTL = (owner) =>
  api.get("/listleadsdata/assignedtodaytl", { params: { owner } });
export const fetchtodaycustTL = (owner) =>
  api.get("/listcustdata/todaytl", { params: { owner } });
export const fetchtodaytripsTL = (owner) =>
  api.get("/listtripsdata/todaytl", { params: { owner } });
export const fetchtodaycanctripsTL = (owner) =>
  api.get("/listtripsdata/canctodaytl", { params: { owner } });
export const fetchtodayhottripsTL = (owner) =>
  api.get("/listtripsdata/hottodaytl", { params: { owner } });
export const fetchtodayconvtripsTL = (owner) =>
  api.get("/listtripsdata/convtodaytl", { params: { owner } });
export const fetchtodayquotesTL = (owner) =>
  api.get("/listquotesdata/todaytl", { params: { owner } });
export const fetchtodayeditquotesTL = (owner) =>
  api.get("/listquotesdata/edittodaytl", { params: { owner } });
export const fetchtodaypostponedtripsTL = (owner) =>
  api.get("/listtripsdata/postponedtodaytl", { params: { owner } });
export const fetchtodayfupTL = (owner) =>
  api.get("/listtripsdata/fuptodaytl", { params: { owner } });
export const fetchupdatedtripstodayTL = (owner) =>
  api.get("/listupdatedtripsdata/todaytl", { params: { owner } });
export const fetchhottripsTL = (owner) =>
  api.get("/hottripstl", { params: { owner } });
export const fetchbookertripsTL = (owner, startdate, enddate) =>
  api.get("/bookertripstl", { params: { owner, startdate, enddate } });
export const fetchbookertripsTL1 = (owner, startdate, enddate) =>
  api.get("/bookertripstl1", { params: { owner, startdate, enddate } });
export const fetchbookertripsTL2 = (owner, startdate, enddate) =>
  api.get("/bookertripstl2", { params: { owner, startdate, enddate } });
export const fetchbookertripsTL3 = (owner, startdate, enddate) =>
  api.get("/bookertripstl3", { params: { owner, startdate, enddate } });
export const fetchbookertripsTL4 = (owner, startdate, enddate) =>
  api.get("/bookertripstl4", { params: { owner, startdate, enddate } });
export const fetchbookertripsTL5 = (owner, startdate, enddate) =>
  api.get("/bookertripstl5", { params: { owner, startdate, enddate } });
export const fetchbookertripsTL6 = (owner, startdate, enddate) =>
  api.get("/bookertripstl6", { params: { owner, startdate, enddate } });
export const currentfupcount = () => api.get("/morningfupcount");
export const fetchtripsbyreceipt = (startdate, enddate) =>
  api.get("/listtripsdata/receipt", { params: { startdate, enddate } });
export const fetchtripsbyaccount = (account) =>
  api.get("/listtripsdata/account", { params: { account } });
export const fetchtripsbypaid = (startdate, enddate) =>
  api.get("/listtripsdata/paid", { params: { startdate, enddate } });
export const fetchtripsbysupplierpending = (startdate, enddate) =>
  api.get("/listtripsdata/supplierpending", { params: { startdate, enddate } });
export const fetchtripsbypaidinternalteam = (startdate, enddate) =>
  api.get("/listtripsdata/supplierinternal", {
    params: { startdate, enddate },
  });
export const fetchtripsbyrefund = (startdate, enddate) =>
  api.get("/listtripsdata/refund", { params: { startdate, enddate } });
export const fetchtripsbychangelog = (startdate, enddate) =>
  api.get("/listtripsdata/changelog", { params: { startdate, enddate } });
export const fetchtripsbysupplierrefund = (startdate, enddate) =>
  api.get("/listtripsdata/supplierrefund", { params: { startdate, enddate } });
export const fetchtripsbyairline = (startdate, enddate) =>
  api.get("/listtripsdata/airline", { params: { startdate, enddate } });

export const rzsearchhotelbyid = (body) => api.post("/rezsearchbyid", body);
export const rzsearchhotelbydest = (body) => api.post("/rezsearchbydest", body);
export const rzprebookhotelbydest = (body) =>
  api.post("/rezprebookbydest", body);
export const rzbookhotel = (body) => api.post("/rezbook", body);
export const rzhoteldetails = (body) => api.post("/rezhoteldetails", body);
export const rzhotelcancel = (body) => api.post("/rezhotelcancel", body);
export const rzbookingdetails = (body) => api.post("/rezbookingdetails", body);
export const rzcpafterbooking = (body) => api.post("/rezcpafterbooking", body);
export const rzcpbooking = (body) => api.post("/rezcpbooking", body);
export const rzcondetails = (body) => api.post("/rezcondetails", body);

export const addrezData = (newRez) => api.post("/loadrezbooikng", newRez);
export const fetchrezconfbooking = () => api.get("/fetchrezconfbooking");
export const fetchrezallbooking = () => api.get("/fetchallrezbooking");
export const updateRezdata = (newRezData) =>
  api.patch("/updaterezconfbooking", newRezData);

export const addTask = (newReq) => api.post("/createtask", newReq);
export const fetchopentasks = () => api.get("/fetchopentasks");
export const fetchTaskbyId = (id) => api.get("/taskdataentry/" + id);
export const fetchTaskbycreateddate = (startdate, enddate) =>
  api.get("/taskcreatedbydate", { params: { startdate, enddate } });
export const fetchTaskbyupdateddate = (startdate, enddate) =>
  api.get("/taskupdatedbydate", { params: { startdate, enddate } });
export const fetchTaskbyassigned = (assignedto) =>
  api.get("/taskcreatedbyassigned", { params: { assignedto } });
export const fetchTaskbyassignedby = (assignedby) =>
  api.get("/taskcreatedbycreated", { params: { assignedby } });
export const fetchTaskbystatus = (status) =>
  api.get("/taskcreatedbystatus", { params: { status } });
export const updateTask = (newReq) => api.patch("/updatetask", newReq);
export const fetchTasksbyOwner = (owner) =>
  api.get("/listtaskdata/taskowner", { params: { owner } });
export const fetchtaskbytripid = (tripid) =>
  api.get("/listtaskdata/tripid", { params: { tripid } });
export const fetchtaskcount = (cuser, role) =>
  api.get("/listtaskcount/taskowner", { params: { cuser, role } });

export const addCandidate = (newReq) => api.post("/createcand", newReq);
export const fetchallCandidates = () => api.get("/fetchallcand");
export const fetchCandidatebyId = (id) => api.get("/canddataentry/" + id);
export const fetchCandidatesbycreateddate = (startdate, enddate) =>
  api.get("/fetchcandbydate", { params: { startdate, enddate } });
export const fetchCandidatesbynumber = (number) =>
  api.get("/fetchcandbynumber", { params: { number } });
export const fetchCandidatesbyscheduleddate = (startdate, enddate) =>
  api.get("/fetchcandbyscheddate", { params: { startdate, enddate } });
export const updateCandidate = (id, newReq) =>
  api.patch("/updatecand/" + id, newReq);

export const updateRulesdata = (id, newRulesData, masterChangeLog) =>
  api.patch("/updateleadrules/" + id, {
    leadrule: newRulesData,
    master_change_log: masterChangeLog,
  });
export const fetchRules = () => api.get("/fetchrules");
export const updateAssetdata = (id, newAssetData) =>
  api.patch("/updateasset/" + id, newAssetData);
export const fetchAsset = () => api.get("/fetchasset");

export const fetchsvToken = (newSV) => api.post("/fetchsvToken", newSV);
export const listsvtoken = () => api.get("/listsvToken");
export const refreshsvToken = () => api.post("/refreshsvToken");
export const updatesvtoken = (newSVData) =>
  api.patch("/updatesvToken", newSVData);
export const makecall = (calldata) => api.post("/makecall", calldata);
export const fetchtripcallbydate = (startdate, enddate) =>
  api.get("/listtripsdata/callbydate", { params: { startdate, enddate } });
export const fetchaudittripcallbydate = (startdate, enddate) =>
  api.get("/listtripsdata/auditcallbydate", { params: { startdate, enddate } });
export const fetchaudittripcallbydate2 = (startdate, enddate) =>
  api.get("/listtripsdata/auditcallbydate2", {
    params: { startdate, enddate },
  });
export const fetchtripcallbyauditdate = (startdate, enddate) =>
  api.get("/listtripsdata/callbyauditdate", { params: { startdate, enddate } });
export const fetchleadcallbydate = (startdate, enddate) =>
  api.get("/listleadsdata/callbydate", { params: { startdate, enddate } });
export const fetchauditleadcallbydate = (startdate, enddate) =>
  api.get("/listleadsdata/auditcallbydate", { params: { startdate, enddate } });
export const fetchleadcallbyauditdate = (startdate, enddate) =>
  api.get("/listleadsdata/callbyauditdate", { params: { startdate, enddate } });
export const fetchtripcalltoday = () => api.get("/listtripsdata/calltoday");
export const fetchleadcalltoday = () => api.get("/listleadsdata/calltoday");
export const fetchtripcallbydateTL = (startdate, enddate, owner) =>
  api.get("/listtripsdata/tlcallbydate", {
    params: { startdate, enddate, owner },
  });
export const fetchleadcallbydateTL = (startdate, enddate, owner) =>
  api.get("/listleadsdata/tlcallbydate", {
    params: { startdate, enddate, owner },
  });

export const fetchIncomingCalls = () => api.get("/listinboundcalls");
export const fetchPDFbyId = (id) => api.post("/genserverpdf", id);
export const fetchpotentialdata = () => api.get("/potentialdata");

export const cronreport = () => api.get("/cronreport");

export const analyzedocs = (documentKey) =>
  api.post("/analyze-s3", { documentKey });
export const getanalyzedocsresult = (JobId) =>
  api.post("/getanalyze-s3", { JobId });

export const uploadsinglefile = (data) =>
  api.post(railwayurl + "/uploadsingledoc", data, {
    timeout: 60000,
    onUploadProgress: (progressEvent) => {
      console.log("Upload progress:", progressEvent.loaded);
    },
  });
export const uploadmultiplefile = () => api.post("/uploadmultipledocs");
export const viewfiles = () => api.get("/viewdocs");
export const deletefile = (name) => api.delete("/deletedocs", { params: name });

export const ggwacampaign = (data) => api.post("/sendggcampaign", data);
export const ggwacampaign2 = (data) => api.post("/sendggcampaign2", data);
export const ggwacampaign3 = (data) => api.post("/sendggcampaign3", data);
export const ggwacampaign4 = (data) => api.post("/sendggcampaign4", data);
export const sendmailtoteam = (data) => api.post("/sendmail3", data);
export const report12pm = () => api.get("/report12pm");
export const fetchcurrentreport = (owner, role) =>
  api.get("/currentreport", { params: { owner, role } });
export const fetchaicurrentreport = (owner, role) =>
  api.get("/aicurrentreport", { params: { owner, role } });
export const get12pmreport = (owner) =>
  api.get("/12pmreport", { params: { owner } });

export const getinsightviaapi = (url2) => api.post("/getinsight", url2);

// Claude-based call insight. Split into start + poll so no single request is
// held open for minutes (Render/Railway terminate long requests).
// start -> kicks off AWS Transcribe, returns { jobName, s3Key }
// status -> poll until { status: 'completed', transcript, summary }
export const startclaudecallinsight = (data) =>
  api.post("/claudecallinsight/start", data, { timeout: 120000 });
export const getclaudecallinsightstatus = (data) =>
  api.post("/claudecallinsight/status", data, { timeout: 60000 });

export const savesignin = (user, time) =>
  api.post("/savesignin", { params: { user, time } });
export const getsignin = (user) => api.get("/getsignin", { params: { user } });
export const createsignin = (user) =>
  api.get("/createsignin", { params: { user } });
export const updatelogout = (user) =>
  api.post("/updatelogout", { params: { user } });
export const todaysignin = (user) => api.get("/todaysignin");

export const startchat = (number) => api.post("/start-chat", number);
export const getchatbydate = (startdate, enddate) =>
  api.get("/getchatbydate", { params: { startdate, enddate } });
export const getchat24 = () => api.get("/getchat24");
export const updatereadflag = (id) => api.patch("/updatereadflag/" + id);

export const loginemail = (email) => api.post("/loginemail", { params: email });
export const verifytoken = (token) =>
  api.post("/verifytoken", { params: token });

export const updatesuperhot = (triparr) =>
  api.patch("/updatesuperhot", { params: triparr });
export const updateincentive = (triparr) =>
  api.patch("/updateincentive", { params: triparr });

export const loadattendance = (triparr) => api.post("/loadattendance");
export const settlupdate = () => api.get("/tlupdate");

export const addQuery = (newQuery) => api.post("/querydataentry", newQuery);
export const getQuerybyId = (id) => api.get("/getquerybyid/" + id);
export const updateQuerysupplier = (supplier) =>
  api.get("/getquerybysupplier", supplier);
export const updateQueryprice = (newQuery) =>
  api.post("/updatequeryprice", newQuery);
export const updateQuerychat = (newQuery) =>
  api.post("/updatequerychat", newQuery);
export const updateQuery = (id, newQuery) =>
  api.patch("/querydataupdate/" + id, newQuery);

export const findtripbypayment = (amount) =>
  api.get("/findtripbypayment", { params: { amount } });
export const fupcount = () => api.get("/fupcount");
export const quotepdf = (link) => api.post("/quotepdf/" + link);

export const threedayprojection = () => api.get("/threedayprojection");
export const fivedayprojection = () => api.get("/fivedayprojection");

export const getaiinfo = (tripid) => api.post("/getaiinfo", tripid);
export const aiquery = (query) => api.post("/aidataquery", query);
//-----------------------------------------------------------------------------------------------------------------------------
// export const fetchInfo = () => axios.get(url+"/listinfodata");
// export const updateInfoData = (id, newinfoData) => axios.patch(url+"/updateinfo", { params: { id, newinfoData}});
// export const fetchCustomers = () => axios.get(url+"/listcustdata/all");
// export const fetchActiveCustomers = () => axios.get(url+"/listcustdata");
// export const fetchCustomerbyId = (id) => axios.get(url+"/custdataentry/"+id);
// export const fetchCustomerbyNumber = (number) => axios.get(url+"/listcustdata/mobilenumber", { params: { number }});
// export const addCustomer = (newCust) => axios.post((url+"/custdataentry"), newCust);
// export const searchCustomersbyNumber = (number) => axios.get((url+"/searchcustbynumber"),{ params: { number }});
// export const searchCustomersbymail = (email) => axios.get((url+"/searchcustbyemail"),{ params: { email }});
// export const fetchCustomersbyOwner =(owner) => axios.get((url+"/listcustdata/owner"),{ params: { owner }});
// export const fetchtodaycust = () => axios.get(url+"/listcustdata/today");
// export const fetchcustbydob = (month) => axios.get(url+"/listcustdatabydob",{ params: { month }});
// export const updateCustdata = (id, newcustData) => axios.patch(url+"/custdataentry/"+id, newcustData);
// export const fetchfutureconvTrips = () => axios.get(url+"/listtripsdata/futureconv");
// export const fetchTrips = () => axios.get(url+"/listtripsdata/all");
// export const fetchActiveTrips = () => axios.get(url+"/listtripsdata");
// export const fetchconvcustdata = (startdate, enddate) => axios.get((url+"/listconvcustdata"),{ params: { startdate, enddate }});
// export const searchupdatedTripsbyDate = (startdate, enddate) => axios.get((url+"/listtripsdata/updatedbydate"),{ params: { startdate, enddate }});
// export const fetchTripsbyStatus = (status) => axios.get((url+"/listtripsdata/status"), { params: { status}});
// export const fetchTripsbyStatusandOwner = (status, owner) => axios.get((url+"/listtripsdata/statusowner"), { params: { status, owner}});
// export const fetchActiveFupTrips = () => axios.get(url+"/listtripsfupdata");
// export const addTrip = (newTrip) => axios.post((url+"/tripdataentry"), newTrip);
// export const addleadTrip = (newTrip) => axios.post((url+"/leadtripdataentry"), newTrip);
// export const deleteTripbyId = (tripid) => axios.post((url+"/tripdatadelete"), { params: { tripid }});
// export const adddupTrip = (newTrip) => axios.post((url+"/duptripentry"), newTrip);
// export const TestTC = (newTrip) => axios.post((url+"/tclead"), newTrip);
// export const fetchTripbyId = (id) => axios.get(url+"/tripdataentry/"+id);
// export const fetchActiveTripsbyTripOwner =(owner) => axios.get((url+"/listtripsdata/tripowner"),{ params: { owner }});
// export const gmailSend =(from, to, subject, body, formData, formData2) => axios.post((url+"/gmailSend"),{ params: { from, to, subject, body, formData, formData2 }});
// export const fetchActiveFupTripsbyTripOwner =(owner) => axios.get((url+"/listtripsdata/tripfupowner"),{ params: { owner }});
// //export const updateTripdata = (id, newtripData) => axios.patch(url+"/tripdataentry/"+newtripData.trip_id, newtripData);
// export const updateTripdata = (id, newtripData) => axios.patch(url+"/tripdataentry/"+id, newtripData);
// export const searchTrips = (owner, startdate, enddate) => axios.get((url+"/searchtrip"),{ params: { owner, startdate, enddate }});
// export const searchpassiveTrips = (status, owner, startdate, enddate) => axios.get((url+"/searchpassivetrip"),{ params: { status, owner, startdate, enddate }});
// export const searchTripsbyDate = (startdate, enddate) => axios.get((url+"/analyticsdata"),{ params: { startdate, enddate }});
// export const searchActiveTripsbyDate = (startdate, enddate) => axios.get((url+"/listactivebydate"),{ params: { startdate, enddate }});
// export const searchQCbyDate = (startdate, enddate) => axios.get((url+"/analyticsqcdata"),{ params: { startdate, enddate }});
// export const searchQEbyDate = (startdate, enddate) => axios.get((url+"/analyticsqedata"),{ params: { startdate, enddate }});
// export const searchconvTripsbyDate = (startdate, enddate) => axios.get((url+"/analyticsconvdata"),{ params: { startdate, enddate }});
// export const searchboTripsbyDate = (startdate, enddate) => axios.get((url+"/analyticsbodata"),{ params: { startdate, enddate }});
// export const searchTripsbyStartDate = (startdate, enddate) => axios.get((url+"/searchtripbystartdate"),{ params: { startdate, enddate }});
// export const searchConvTripsbyStartDate = (startdate, enddate) => axios.get((url+"/searchconvtripbystartdate"),{ params: { startdate, enddate }});
// export const searchTripsbyStartDateandowner = (startdate, enddate, cuser) => axios.get((url+"/searchtripbystartdateowner"),{ params: { startdate, enddate, cuser }});
// export const searchcancTripsbyDate = (startdate, enddate) => axios.get((url+"/analyticscancdata"),{ params: { startdate, enddate }});
// export const searchallTripsbyDate = (startdate, enddate) => axios.get((url+"/analyticsalldata"),{ params: { startdate, enddate }});
// export const searchclosedTripsbyDate = (startdate, enddate) => axios.get((url+"/analyticscloseddata"),{ params: { startdate, enddate }});
// export const searchhotTripsbyDate = (startdate, enddate) => axios.get((url+"/analyticshotdata"),{ params: { startdate, enddate }});
// export const searchpotentialTripsbyDate = (startdate, enddate) => axios.get((url+"/analyticspotdata"),{ params: { startdate, enddate }});
// export const searchQuotesbyDate = (startdate, enddate, dest) => axios.get((url+"/analyticsquotedata"),{ params: { startdate, enddate, dest }});
// export const searchLeadsbyDate = (startdate, enddate) => axios.get((url+"/analyticsleadsdata"),{ params: { startdate, enddate }});
//export const searchupdatedLeadsbyDate = (startdate, enddate) => axios.get((url+"/listupdatedleadsdata"),{ params: { startdate, enddate }});
// export const searchconvTripsbyStartDate = (startdate, enddate) => axios.get((url+"/analyticsstartdata"),{ params: { startdate, enddate }});
//export const fetchupdatedtripsbyDate = (startdate, enddate) => axios.get((url+"/analyticscalldata"),{ params: { startdate, enddate }});
// export const fetchReftrips = (startdate, enddate) => axios.get((url+"/listtripsdata/reftrips"),{ params: { startdate, enddate }});
// export const fetchFollowups = () => axios.get(url+"/fup");
// export const fetchtodaytrips = () => axios.get(url+"/listtripsdata/today");
// export const fetchtodaycanctrips = () => axios.get(url+"/listtripsdata/canctoday");
// export const fetchtodayhottrips = () => axios.get(url+"/listtripsdata/hottoday");
// export const fetchtodayconvtrips = () => axios.get(url+"/listtripsdata/convtoday");
// export const fetchtodaypostponedtrips = () => axios.get(url+"/listtripsdata/postponedtoday");
// export const fetchtodayfup = () => axios.get(url+"/listtripsdata/fuptoday");
// export const fetchupdatedtodaytrips = () => axios.get(url+"/listupdatedtripsdata/today");
// export const fetchfupbydate = (startdate, enddate) => axios.get(url+"/listtripsdata/fupbydate", { params: { startdate, enddate }});
// export const fetchnrfupbydate = (startdate, enddate) => axios.get(url+"/listtripsdata/nrfupbydate", { params: { startdate, enddate }});
//export const fetchcancflagbydate = (startdate, enddate) => axios.get(url+"/listtripsdata/cancflagbyDate", { params: { startdate, enddate }});
//export const fetchcancflagbydateandowner = (startdate, enddate, owner) => axios.get(url+"/listtripsdata/cancflagbyDateandowner", { params: { startdate, enddate, owner }});
//export const fetchquotedatesonly = (id) => axios.get(url+"/listquotesdata/getquotedatesonly", { params: { id }});
//export const canceltripbytripid = (id) => axios.get(url+"/canctripbytripid", { params: { id }});

// export const addHotel = (newHotel) => axios.post((url+"/hoteldataentry"), newHotel);
// export const fetchHotels = () => axios.get(url+"/listhoteldata");
// export const fetchHotelsname = () => axios.get(url+"/listhoteldata/name");
// export const fetchHotelbyId = (id) => axios.get(url+"/hoteldataentry/"+id);
// export const fetchdestHotels =(tripid) => axios.get((url+"/listhoteldata/tripid"),{ params: { tripid }});
// export const fetchdestHotelsbyDest =(dest) => axios.get((url+"/listhoteldata/dest"),{ params: { dest }});
// export const fetchdestHotelsbyDestandCity =(dest, city) => axios.get((url+"/listhoteldata/destandcity"),{ params: { dest, city }});
// export const fetchdestHotelsbyQuoteid =(quoteid) => axios.get((url+"/listhoteldata/quoteid"),{ params: { quoteid }});
// export const fetchHotelsbyUSP = (data, dest) => axios.get((url+"/searchhotelbyusp"),{ params: { data, dest }});
// export const fetchHotelsbyTagsOr = (tag1, tag2, tag3, tag4, tag5, tag6, tag7, tag8, data) => axios.get((url+"/searchhotelbytagsor"),{ params: { tag1, tag2, tag3, tag4, tag5, tag6, tag7, tag8, data}});
// export const fetchHotelsbyTagsAnd = (tag1, tag2, tag3, tag4, tag5, tag6, tag7, tag8, data) => axios.get((url+"/searchhotelbytagsand"),{ params: { tag1, tag2, tag3, tag4, tag5, tag6, tag7, tag8, data}});
// //export const updateHoteldata = (id, newhotelData) => axios.patch(url+"/hoteldataentry/"+newhotelData.hotel_id, newhotelData);
// export const updateHoteldata = (id, newhotelData) => axios.patch(url+"/hoteldataentry/"+id, newhotelData);
// export const addTour = (newTour) => axios.post((url+"/tourdataentry"), newTour);
// export const fetchTours = () => axios.get(url+"/listtourdata");
// export const fetchdestTours =(tripid) => axios.get((url+"/listtourdata/tripid"),{ params: { tripid }});
// export const fetchdestToursbyQuoteid =(quoteid) => axios.get((url+"/listtourdata/quoteid"),{ params: { quoteid }});
// export const fetchdestToursbyDest =(dest) => axios.get((url+"/listtourdata/dest"),{ params: { dest }});
// export const fetchTourbyId = (id) => axios.get(url+"/tourdataentry/"+id);
// //export const updateTourdata = (id, newtourData) => axios.patch(url+"/tourdataentry/"+newtourData.tour_id, newtourData);
// export const updateTourdata = (id, newtourData) => axios.patch(url+"/tourdataentry/"+id, newtourData);
// export const fetchSuppliers = () => axios.get(url+"/listsupplierdata");
// export const fetchSuppliersbyDest2 = (dest) => axios.get((url+"/listsupplierdata/dest2"), { params: { dest }});
// export const addSupplier = (newSupplier) => axios.post((url+"/supplierdataentry"), newSupplier);
// export const fetchSupplierbyId = (id) => axios.get(url+"/supplierdataentry/"+id);
// export const updateSupplierdata = (id, newsupplierData) => axios.patch(url+"/supplierdataentry/"+id, newsupplierData);
// export const fetchDest = () => axios.get(url+"/listdest");

// export const fetchConvertedTrips = () => axios.get(url+"/home/owner");
// export const fetchConvertedTripsOnly = () => axios.get(url+"/listtripsdata/convonly");
// export const fetchConvertedTripsbyTripOwner = (owner) => axios.get((url+"/listtripsdata/convowner"), { params: { owner }});
// export const fetchConvertedTripsbyTripOwnerOnly = (owner) => axios.get((url+"/home/all"), { params: { owner }});
// export const fetchCanc = (cancdate) => axios.get((url+"/home/canc"), { params: { cancdate }});
// export const fetchCancbyOwner = (owner, cancdate) => axios.get((url+"/home/cancowner"), { params: { owner, cancdate }});
// export const fetchSuppliersbyDest = (dest) => axios.get((url+"/listsupplierdata/dest"),{ params: { dest }});

// export const fetchEmployees = () => axios.get(url+"/listemployeedata");
// export const fetchEmployeebyId = (id) => axios.get(url+"/employeedataentry/"+id);
// export const addEmployee = (newEmployee) => axios.post((url+"/employeedataentry"), newEmployee);
// export const updateEmployeedata = (id, newemployeeData) => axios.patch(url+"/employeedataentry/"+id, newemployeeData);

// export const addquoteData = (newQuote) => axios.post((url+"/quotedataentry"), newQuote);
// export const fetchfavQuotes = () => axios.get(url+"/listquotedata");
// export const fetchfavQuotesbyDest = (dest) => axios.get((url+"/listquotesdata/dest"), { params: { dest }});
// export const fetchQuotebyId = (id) => axios.get(url+"/quotedataentry/"+id);
// export const updatequoteData = (id, newquoteData) => axios.patch(url+"/quotedataentry/"+id, newquoteData);
// export const fetchEmployeebyName = (name) => axios.get(url+"/employeedatasearch/"+name);
// export const fetchTeambyName = (name) => axios.get(url+"/teamdatasearch/"+name);
// export const fetchEmployeebyEmail = (email) => axios.get(url+"/employeedatasearchbymail/"+email);
// export const fetchtodayquotes = () => axios.get(url+"/listquotesdata/today");
// export const fetchtodayeditquotes = () => axios.get(url+"/listquotesdata/edittoday");
// export const fetchpotentialhot = () => axios.get(url+"/potentialhot");
// export const fetchquotetoday = () => axios.get(url+"/quotetoday");
// export const fetchquotefromtrip = (quotelist) => axios.get((url+"/listquotesdata/getquotefromtrip"), { params: { quotelist }});

// export const addLead = (newLead) => axios.post((url+"/lead"), newLead);
// export const addTCLeads = (hh,mm) => axios.post((url+"/tclead"),{ params: { hh,mm }} );
// export const fetchLeads = () => axios.get(url+"/listleadsdata/all");
//export const fetchLeads15 = () => axios.get(url+"/listleadsdata/last15days");
// export const fetchLeadsbyNumber = (number) => axios.get(url+"/listleadsdata/leadnumber", { params: { number }});
// export const fetchTripsbyNumber = (number) => axios.get(url+"/listtripsdata/mobilenumber", { params: { number }});
// export const fetchLeadsbyEmail = (email) => axios.get(url+"/listleadsdata/leademail", { params: { email }});
// export const fetchLeadsbyTripOwner =(owner) => axios.get((url+"/listleadsdata/leadowner"),{ params: { owner }});
// export const fetchLeadsTodaybyTripOwner =(owner) => axios.get((url+"/listleadsdata/todayowner"),{ params: { owner }});
// export const fetchLeadbyId = (id) => axios.get(url+"/lead/"+id);
// export const updateLeaddata = (id, newleadData) => axios.patch(url+"/lead/"+id, newleadData);
// export const fetchquotelist = (dest) => axios.get((url+"/quotelist"), {params:{dest}});
// export const fetchtodayleads = () => axios.get(url+"/listleadsdata/today");
// export const fetchtodayassignedleads = () => axios.get(url+"/listleadsdata/assignedtoday");
// export const fetchworkdoneleads = () => axios.get(url+"/listleadsdata/workdonetoday");

// export const dupcustCheck = () => axios.get(url+"/dupcustcheck");
// export const duptripCheck = () => axios.get(url+"/duptripcheck");
// export const dupquoteCheck = () => axios.get(url+"/dupquotecheck");
// export const duphotelCheck = () => axios.get(url+"/duphotelcheck");
// export const dupleadCheck = () => axios.get(url+"/dupleadcheck");
// export const duptourCheck = () => axios.get(url+"/duptourcheck");
// export const dupcustnumberCheck = () => axios.get(url+"/dupcustnumbercheck");

// export const fetchwadata = () => axios.get(url+"/listwadata/all");
// export const addMsg = (newMsg) => axios.post((url+"/wamsg"), newMsg);
// export const fetchcurrency = (currencyname) => axios.get(erurl+currencyname);
// export const fetchCurrencyData=() => axios.get(url+"/listcurrency")
// export const updateCurrencyData = (id, newcurrencyData) => axios.patch(url+"/updatecurrency", { params: { id, newcurrencyData}});
// export const fetchVisaData=() => axios.get(url+"/listvisa")

// export const fetchTokenData=() => axios.get(url+"/listtoken")
// export const fetchToken=(body) => axios.post(url+"/fetchtoken", body)
// export const updateTokenData = (id, newtokenData) => axios.patch(url+"/updatetoken", { params: { id, newtokenData}});

// export const fetchflights=(body) => axios.post(url+"/searchflights", body)
// export const fetchfarerule=(body) => axios.post(url+"/farerule", body)
// export const fetchfarequote=(body) => axios.post(url+"/farequote", body)
// export const fetchssr=(body) => axios.post(url+"/ssr", body)
// export const fetchbook=(body) => axios.post(url+"/bookflight", body)
// export const fetchticket=(body) => axios.post(url+"/ticket", body)
// export const fetchdetails=(body) => axios.post(url+"/getdetails", body)
// export const releasepnr=(body) => axios.post(url+"/releasepnr", body)
// export const cancelflight=(body) => axios.post(url+"/cancelflight", body)
// export const requeststatus=(body) => axios.post(url+"/requeststatus", body)
// export const getcpafterflightbooking=(body) => axios.post(url+"/getflightcp", body)

// export const addflightData = (newTBO) => axios.post((url+"/loadflightbooikng"), newTBO);
// export const fetchflightconfbooking = () => axios.get(url+"/fetchflightconfirmBooking");
// export const fetchflightallbooking = () => axios.get(url+"/fetchallflightbooking");
// export const updateflightdata = (newTBOData) => axios.patch(url+"/updateflightconfbooking", newTBOData);

// export const puppeteertest= (msg) => axios.post((url+"/puppeteer"),msg)
// export const bulkmsg= (list, msg) => axios.post((url+"/bulkmsg1"),{ params: { list, msg}})
// export const leadassignment= () => axios.get(url+"/leadassignment");

// export const imgupload= (data) => axios.post((url+"/imgupload"),data)
// export const imgdelete= (data) => axios.delete((url+"/imgdelete"),{ params: {data}})
// export const downloadfile= (data) => axios.get((url+"/downloadfile"),{ params: {data}},{responseType: 'arraybuffer'})

// export const startcron= () => axios.get(url+"/startcron");
// export const stopcron= () => axios.get(url+"/stopcron");
// export const cancflag= () => axios.get(url+"/runcancflag");

// export const fetchActiveTripsbyTL =(owner) => axios.get((url+"/listtripsdata/tl"),{ params: { owner }});
// export const fetchConvertedTripsbyTL = (owner) => axios.get((url+"/listtripsdata/convtl"), { params: { owner }});
// export const fetchConvertedTripsbyTLnDate = (owner, startdate, enddate) => axios.get((url+"/listtripsdata/convtlndate"), { params: { owner, startdate, enddate }});
// export const fetchCancbyTL = (owner, cancdate) => axios.get((url+"/home/canctl"), { params: { owner, cancdate }});
// export const fetchLeadsbyTL =(owner) => axios.get((url+"/listleadsdata/leadtl"),{ params: { owner }});
// export const fetchCustomersbyTL =(owner) => axios.get((url+"/listcustdata/tl"),{ params: { owner }});
// export const fetchTripsbyStatusTL = (status, owner) => axios.get((url+"/listtripsdata/statustl"), { params: { status, owner}});
// export const fetchActiveTripsTL = (owner) => axios.get(url+"/listtripsdatatl", { params: { owner }});
// export const fetchtodayassignedleadsTL = (owner) => axios.get(url+"/listleadsdata/assignedtodaytl", { params: { owner }});
// export const fetchtodaycustTL = (owner) => axios.get(url+"/listcustdata/todaytl", { params: { owner }});
// export const fetchtodaytripsTL = (owner) => axios.get(url+"/listtripsdata/todaytl", { params: { owner }});
// export const fetchtodaycanctripsTL = (owner) => axios.get(url+"/listtripsdata/canctodaytl", { params: { owner }});
// export const fetchtodayhottripsTL = (owner) => axios.get(url+"/listtripsdata/hottodaytl", { params: { owner }});
// export const fetchtodayconvtripsTL = (owner) => axios.get(url+"/listtripsdata/convtodaytl", { params: { owner }});
// export const fetchtodayquotesTL = (owner) => axios.get(url+"/listquotesdata/todaytl", { params: { owner }});
// export const fetchtodayeditquotesTL = (owner) => axios.get(url+"/listquotesdata/edittodaytl", { params: { owner }});
// export const fetchtodaypostponedtripsTL = (owner) => axios.get(url+"/listtripsdata/postponedtodaytl", { params: { owner }});
// export const fetchtodayfupTL = (owner) => axios.get(url+"/listtripsdata/fuptodaytl", { params: { owner }});
//export const fetchupdatedtripstodayTL = (owner) => axios.get(url+"/listupdatedtripsdata/todaytl", { params: { owner }});

// export const fetchtripsbyreceipt = (startdate, enddate) => axios.get((url+"/listtripsdata/receipt"), { params: { startdate, enddate }});
// export const fetchtripsbypaid = (startdate, enddate) => axios.get((url+"/listtripsdata/paid"), { params: { startdate, enddate }});

// export const rzsearchhotelbyid=(body) => axios.post(url+"/rezsearchbyid", body)
// export const rzsearchhotelbydest=(body) => axios.post(url+"/rezsearchbydest", body)
// export const rzprebookhotelbydest=(body) => axios.post(url+"/rezprebookbydest", body)
// export const rzbookhotel=(body) => axios.post(url+"/rezbook", body)
// export const rzhoteldetails=(body) => axios.post(url+"/rezhoteldetails", body)
// export const rzhotelcancel=(body) => axios.post(url+"/rezhotelcancel", body)
// export const rzbookingdetails=(body) => axios.post(url+"/rezbookingdetails", body)
// export const rzcpafterbooking=(body) => axios.post(url+"/rezcpafterbooking", body)
// export const rzcpbooking=(body) => axios.post(url+"/rezcpbooking", body)
// export const rzcondetails=(body) => axios.post(url+"/rezcondetails", body)

// export const addrezData = (newRez) => axios.post((url+"/loadrezbooikng"), newRez);
// export const fetchrezconfbooking = () => axios.get(url+"/fetchrezconfbooking");
// export const fetchrezallbooking = () => axios.get(url+"/fetchallrezbooking");
// export const updateRezdata = (newRezData) => axios.patch(url+"/updaterezconfbooking", newRezData);

// export const addTask = (newReq) => axios.post((url+"/createtask"), newReq);
// export const fetchopentasks = () => axios.get(url+"/fetchopentasks");
// export const fetchTaskbyId = (id) => axios.get(url+"/taskdataentry/"+id);
// export const fetchTaskbycreateddate = (startdate, enddate ) => axios.get(url+"/taskcreatedbydate",{ params: { startdate, enddate }});
// export const fetchTaskbyupdateddate = (startdate, enddate ) => axios.get(url+"/taskupdatedbydate", { params: { startdate, enddate }});
// export const updateTask = (newReq) => axios.patch(url+"/updatetask", newReq);
// export const fetchTasksbyOwner =(owner) => axios.get((url+"/listtaskdata/taskowner"),{ params: { owner }});

// export const updateRulesdata = (id, newRulesData) => axios.patch(url+"/updateleadrules/"+id, newRulesData);
// export const fetchRules= () => axios.get(url+"/fetchrules");

// export const fetchsvToken = (newSV) => axios.post((url+"/fetchsvToken"), newSV);
// export const listsvtoken = () => axios.get(url+"/listsvToken");
// export const refreshsvToken = () => axios.post(url+"/refreshsvToken");
// export const updatesvtoken = (newSVData) => axios.patch(url+"/updatesvToken", newSVData);
// export const makecall = (calldata) => axios.post((url+"/makecall"), calldata);

//export const fetchtripcallbydate = (startdate, enddate ) => axios.get(url+"/listtripsdata/callbydate", { params: { startdate, enddate }});
//export const fetchleadcallbydate = (startdate, enddate ) => axios.get(url+"/listleadsdata/callbydate", { params: { startdate, enddate }});
//export const fetchtripcalltoday = () => axios.get(url+"/listtripsdata/calltoday");
//export const fetchleadcalltoday = () => axios.get(url+"/listleadsdata/calltoday");
//export const fetchtripcallbydateTL = (startdate, enddate, owner ) => axios.get(url+"/listtripsdata/tlcallbydate", { params: { startdate, enddate, owner }});
//export const fetchleadcallbydateTL = (startdate, enddate, owner ) => axios.get(url+"/listleadsdata/tlcallbydate", { params: { startdate, enddate, owner }});

//export const fetchIncomingCalls = () => axios.get(url+"/listinboundcalls");
